import { render, staticRenderFns } from "./UserChangeLogsDetailsView.vue?vue&type=template&id=0b4ccca6&scoped=true"
import script from "./UserChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./UserChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./UserChangeLogsDetailsView.vue?vue&type=style&index=0&id=0b4ccca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ccca6",
  null
  
)

export default component.exports